import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

import { GenericChartComponent } from '../../../../shared/echarts/components/generic-chart/generic-chart.component';
import { MatrixCardComponent } from '../../../../shared/components/matrix-card/matrix-card.component';
import { LoadingComponent } from '../../../../shared/components/loading/loading.component';
import type { MidasAiVideosCardData } from '../../services/dashboard-mock.service';
import { DASHBOARD_DATA } from '../../services/dashboard-data.token';

@Component({
  selector: 'app-midas-ai-videos-card',
  standalone: true,
  imports: [CommonModule, GenericChartComponent, MatrixCardComponent, TranslateModule, LoadingComponent],
  templateUrl: './midas-ai-videos-card.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MidasAiVideosCardComponent implements OnInit {
  @Input() highlighted = false;

  private readonly dashboardData = inject(DASHBOARD_DATA);
  private readonly destroyRef = inject(DestroyRef);

  readonly loading = signal(true);
  readonly data = signal<MidasAiVideosCardData | null>(null);

  ngOnInit(): void {
    this.dashboardData
      .getMidasAiVideosCardData()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (d) => {
          this.data.set(d);
          this.loading.set(false);
        },
        error: () => {
          this.data.set(null);
          this.loading.set(false);
        },
      });
  }
}


